import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import styles from '../../../styles/icons/base.module.scss';

const propTypes = {
    locked: PropTypes.bool,
    color: PropTypes.string,
    className: PropTypes.string,
};

const defaultProps = {
    locked: true,
    color: 'currentColor',
    className: null,
};

function LockIcon({ locked, color, className }) {
    return locked ? (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="25"
            height="25"
            viewBox="0 0 25 25"
            fill="none"
            className={classNames([styles.container, { [className]: className !== null }])}
        >
            <path
                d="M8.35588 20.3123C7.96302 20.3123 7.62671 20.1724 7.34695 19.8926C7.06719 19.6129 6.92731 19.2765 6.92731 18.8837V11.7408C6.92731 11.348 7.06719 11.0117 7.34695 10.7319C7.62671 10.4521 7.96302 10.3123 8.35588 10.3123H9.07016V8.88368C9.07016 7.89559 9.41838 7.05333 10.1148 6.3569C10.8112 5.66047 11.6535 5.31226 12.6416 5.31226C13.6297 5.31226 14.472 5.66047 15.1684 6.3569C15.8648 7.05333 16.213 7.89559 16.213 8.88368V10.3123H16.9273C17.3202 10.3123 17.6565 10.4521 17.9362 10.7319C18.216 11.0117 18.3559 11.348 18.3559 11.7408V18.8837C18.3559 19.2765 18.216 19.6129 17.9362 19.8926C17.6565 20.1724 17.3202 20.3123 16.9273 20.3123H8.35588ZM12.6416 16.7408C13.0345 16.7408 13.3708 16.6009 13.6505 16.3212C13.9303 16.0414 14.0702 15.7051 14.0702 15.3123C14.0702 14.9194 13.9303 14.5831 13.6505 14.3033C13.3708 14.0236 13.0345 13.8837 12.6416 13.8837C12.2487 13.8837 11.9124 14.0236 11.6327 14.3033C11.3529 14.5831 11.213 14.9194 11.213 15.3123C11.213 15.7051 11.3529 16.0414 11.6327 16.3212C11.9124 16.6009 12.2487 16.7408 12.6416 16.7408ZM10.4987 10.3123H14.7845V8.88368C14.7845 8.28845 14.5761 7.78249 14.1595 7.36583C13.7428 6.94916 13.2368 6.74083 12.6416 6.74083C12.0464 6.74083 11.5404 6.94916 11.1237 7.36583C10.7071 7.78249 10.4987 8.28845 10.4987 8.88368V10.3123Z"
                fill={color}
            />
        </svg>
    ) : (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            className={classNames([styles.container, { [className]: className !== null }])}
        >
            <path
                d="M10.9285 16.7408C11.3214 16.7408 11.6577 16.6009 11.9374 16.3212C12.2172 16.0414 12.3571 15.7051 12.3571 15.3123C12.3571 14.9194 12.2172 14.5831 11.9374 14.3033C11.6577 14.0236 11.3214 13.8837 10.9285 13.8837C10.5357 13.8837 10.1994 14.0236 9.91959 14.3033C9.63983 14.5831 9.49995 14.9194 9.49995 15.3123C9.49995 15.7051 9.63983 16.0414 9.91959 16.3212C10.1994 16.6009 10.5357 16.7408 10.9285 16.7408ZM6.6428 20.3123C6.24995 20.3123 5.91364 20.1724 5.63388 19.8926C5.35411 19.6129 5.21423 19.2765 5.21423 18.8837V11.7408C5.21423 11.348 5.35411 11.0117 5.63388 10.7319C5.91364 10.4521 6.24995 10.3123 6.6428 10.3123H11.6428V8.88368C11.6428 7.89559 11.991 7.05333 12.6874 6.3569C13.3839 5.66047 14.2261 5.31226 15.2142 5.31226C16.2023 5.31226 17.0446 5.66047 17.741 6.3569C18.4374 7.05333 18.7857 7.89559 18.7857 8.88368H17.3571C17.3571 8.28845 17.1488 7.78249 16.7321 7.36583C16.3154 6.94916 15.8095 6.74083 15.2142 6.74083C14.619 6.74083 14.113 6.94916 13.6964 7.36583C13.2797 7.78249 13.0714 8.28845 13.0714 8.88368V10.3123H15.2142C15.6071 10.3123 15.9434 10.4521 16.2232 10.7319C16.5029 11.0117 16.6428 11.348 16.6428 11.7408V18.8837C16.6428 19.2765 16.5029 19.6129 16.2232 19.8926C15.9434 20.1724 15.6071 20.3123 15.2142 20.3123H6.6428Z"
                fill={color}
            />
        </svg>
    );
}

LockIcon.propTypes = propTypes;
LockIcon.defaultProps = defaultProps;

export default LockIcon;
